"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.network = void 0;
var core_common_1 = require("./core-common");
var logging_1 = require("./logging");
$(function () {
    (0, logging_1.logScriptLoad)("[core] [network]");
});
exports.network = {
    fetchData: function fetchData(url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, body, json, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, logging_1.log)("Entering method.", 3 /* LogType.Information */, "fetchData");
                        (0, core_common_1.clearAndHideInfoBar)();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        (0, logging_1.log)("Calling url: ".concat(url), 3 /* LogType.Information */, "fetchData");
                        return [4 /*yield*/, fetch(url)];
                    case 2:
                        response = _a.sent();
                        if (!((response === null || response === void 0 ? void 0 : response.status) === 500)) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json().catch(function () { return null; })];
                    case 3:
                        body = _a.sent();
                        if ((body === null || body === void 0 ? void 0 : body.code) === "ExternalServiceFailure" || (body === null || body === void 0 ? void 0 : body.code) === "InternalApiError") {
                            (0, logging_1.log)("Upstream failure calling '".concat(url, "', showing callback request form."), 1 /* LogType.Error */, "fetchData");
                            (0, core_common_1.showRetailerInfoDialog)();
                            return [2 /*return*/, { success: false, count: 0, view: "" }];
                        }
                        _a.label = 4;
                    case 4:
                        if (!response || !response.ok) {
                            throw new Error("Network error calling ".concat(url, ": ").concat(response.statusText));
                        }
                        return [4 /*yield*/, response.json()];
                    case 5:
                        json = _a.sent();
                        return [2 /*return*/, json];
                    case 6:
                        err_1 = _a.sent();
                        (0, logging_1.log)("Error calling '".concat(url, "': ").concat(err_1.message), 1 /* LogType.Error */, "fetchData");
                        throw err_1;
                    case 7:
                        (0, logging_1.log)("Leaving method.", 3 /* LogType.Information */, "fetchData");
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
};
